export default "__VITE_ASSET__4108db71__"